export interface IUserProfile {
    email: string;
    firstName?: string;
    lastName?: string;
    linkedInUrl?: string;
    phone?: string;
    dataSharing?: boolean;
    marketingOptIn?: boolean;

    linkedInExportDate?: Date;
    linkedInConnectionCount?: number;
    isPartner?: boolean;
    stripeAccount?: IStripeAccount;
    profileImageUrl?: string;
}

export enum OnboardingState {
    NOTSTARTED,
    INCOMPLETE,
    RESTRICTED,
    ENABLED,
}

export interface IStripeAccount {
    stripeAccountId: string | null;
    onboardingState: OnboardingState;
    chargesEnabled: boolean;
    payoutsEnabled: boolean;
    disabledReason: string | null;
    currentlyDue: string[];
    pastDue: string[];
    requirementsDeadline: string | null;
    lastSyncedAt: string | null;
}

export interface IStripeAccountLink {
    url: string;
    expiresAt: string;
    profile: IStripeAccount;
}
